import {CacheableWrapper} from '@aboutyou/cacheable-components';
import {
  CACHEABLE_HEADER_PLACEHOLDER,
  CacheableHeader as CacheableTadaridaHeader,
  Header as TadaridaHeader,
} from '@aboutyou/logic-components';
import React from 'react';
import {AppProviders} from '../../../AppProviders';

export const Header: React.FC = () => {
  return (
    <CacheableWrapper placeholder={CACHEABLE_HEADER_PLACEHOLDER}>
      <TadaridaHeader voucherToastsShowDirection="down" />
    </CacheableWrapper>
  );
};

export const CacheableHeader: React.FC = () => {
  return (
    <AppProviders>
      <CacheableTadaridaHeader voucherToastsShowDirection="down" />
    </AppProviders>
  );
};
